import { connect } from 'react-redux';

import { VODCSSModules } from 'shared/utils/wix-connect';
import { getNewRelic } from 'shared/analytics/new-relic';

import { getMainVideoId } from 'widget/ui-selectors/selected-video-id';

import { DATA_KEY } from 'widget/data-components/paginated-channel-videos';

import BaseView from 'widget/views/_base';

import UpdateWidgetSize from 'widget/data-components/update-widget-size';
import PaymentEvents from 'shared/components/payment-events/payment-events';
import ReloadStorage from 'widget/components/reload-storage/reload-storage';

import ChanelActions from 'widget/views/desktop/compact/components/channel-actions/channel-actions';
import Player from 'widget/views/desktop/compact/components/player/player';
import Videos from 'widget/views/desktop/compact/components/videos/videos';

import styles from './compact.styl';

const DEFAULT_STATE = {
  canShowChannelCover: true,
  areAllVideosVisible: false,
};


@connect((state, ownProps) => ({
  mainVideoId: getMainVideoId(state, ownProps, DATA_KEY),
  // Provide selectors here for paginatedChannelVideos
  ids: [],
  prevPageIds: [],
  nextPageIds: [],
}))
@VODCSSModules(styles)
export default class CompactView extends BaseView {
  static displayName = 'CompactView';

  static propTypes = {
    mainVideoId: React.PropTypes.string,
    ids: React.PropTypes.arrayOf(React.PropTypes.string),
    prevPageIds: React.PropTypes.arrayOf(React.PropTypes.string),
    nextPageIds: React.PropTypes.arrayOf(React.PropTypes.string),
  };

  constructor(props) {
    super(props);

    this.state = DEFAULT_STATE;
    getNewRelic().setCustomAttribute('layout', 'compact');
  }

  showAllVideos() {
    this.setState({
      areAllVideosVisible: true,
    });
  }

  hideAllVideos() {
    this.setState({
      areAllVideosVisible: false,
    });
  }

  get player() {
    const mainVideo = this.mainVideo;

    if (!mainVideo) {
      // TODO Move to component
      // each initial state need to be a single component
      return this.noVideosPlayerContent;
    }

    // TODO wrap with container to provide playback actions like onPlayRequested
    // wrapper, not pure actions needed because of different logic for views
    // Also can be done as view specific actions (need to discuss)
    return (
      <Player video={mainVideo} />
    );
  }

  get videos() {
    const { ids, prevPageIds, nextPageIds } = this.props;
    // TODO wrap with container to provide playback actions like onNextPage
    // wrapper, not pure actions needed because of different logic for views
    // Also can be done as view specific actions (need to discuss)
    return (
      <Videos ids={ids}
              prevPageIds={prevPageIds}
              nextPageIds={nextPageIds} />
    );
  }

  get showVideosButton() {
    return (
      <button styleName="show-all-videos"
              onClick={this.showAllVideos}>
        TODO: add icon at css
      </button>
    );
  }

  get actions() {
    return (
      // TODO wrap with container to provide playback actions like onShareRequested
      // wrapper, not pure actions needed because of different logic for views
      // Also can be done as view specific actions (need to discuss)
      <ChanelActions onClose={this.hideAllVideos} />
    );
  }

  get isVideosLoaded() {
    const { videoByIds, paginatedChannelVideos } = this.props;
    return !paginatedChannelVideos.isFetching || !_.isEmpty(videoByIds);
  }

  render() {
    if (!this.isUIBlockingDataLoaded || !this.isVideosLoaded) {
      return this.spinner;
    }

    const { areAllVideosVisible } = this.props;
    return (
      <section styleName="container"
               ref={this.setContainerEl}
               className="qa-widget-container">
        <UpdateWidgetSize />
        <ReloadStorage onReload={this.processDataFromStorage} />

        <div className="content"
             style={this.playerSize}>
          {areAllVideosVisible ? this.videos : this.player}
        </div>

        {areAllVideosVisible ? this.actions : this.showVideosButton}

        <PaymentEvents onRent={this.setCurrentVideoFromPayment}
                       onSale={this.setCurrentVideoFromPayment}
                       onSubscription={this.reset}
                       onSubscriptionCancel={this.reset} />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/compact.js